"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    textAligns: ()=>textAligns,
    textVariants: ()=>textVariants,
    headingAsVariants: ()=>headingAsVariants,
    lineClamps: ()=>lineClamps,
    wordBreakVariants: ()=>wordBreakVariants,
    lineClampVariants: ()=>lineClampVariants,
    headingVariants: ()=>headingVariants,
    textAlignVariants: ()=>textAlignVariants,
    textOverflowVariants: ()=>textOverflowVariants,
    textUnderlines: ()=>textUnderlines,
    wordBreaks: ()=>wordBreaks,
    headingAs: ()=>headingAs,
    textOverflows: ()=>textOverflows,
    textWrapVariants: ()=>textWrapVariants,
    textVariantsFields: ()=>textVariantsFields,
    textWraps: ()=>textWraps
});
const foreground_cjs_namespaceObject = require("./palette/foreground.cjs");
const baseTextVariants_cjs_namespaceObject = require("./text/baseTextVariants.cjs");
const external_tv_cjs_namespaceObject = require("./tv.cjs");
const textAlignVariants = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
    justify: 'text-justify'
};
const textAligns = Object.keys(textAlignVariants);
const textOverflowVariants = {
    truncate: 'truncate',
    ellipsis: 'text-ellipsis overflow-hidden',
    clip: 'text-clip overflow-hidden'
};
const textOverflows = Object.keys(textOverflowVariants);
const textWrapVariants = {
    wrap: 'text-wrap',
    nowrap: 'text-nowrap',
    balance: 'text-balance',
    pretty: 'text-pretty'
};
const textWraps = Object.keys(textWrapVariants);
const lineClampVariants = {
    1: 'line-clamp-1',
    2: 'line-clamp-2',
    3: 'line-clamp-3',
    4: 'line-clamp-4',
    5: 'line-clamp-5',
    6: 'line-clamp-6',
    none: 'line-clamp-none'
};
const lineClamps = Object.keys(lineClampVariants);
const wordBreakVariants = {
    breakNormal: 'break-normal',
    breakWords: 'break-words',
    breakKeep: 'break-keep'
};
const wordBreaks = Object.keys(wordBreakVariants);
const textVariants = (0, external_tv_cjs_namespaceObject.tv)({
    extend: foreground_cjs_namespaceObject.foregroundPaletteVariants,
    variants: {
        textStyle: baseTextVariants_cjs_namespaceObject.textStyleVariants,
        italic: {
            true: 'italic'
        },
        bold: {
            true: 'font-bold'
        },
        align: textAlignVariants,
        underline: {
            solid: 'underline underline-offset-2',
            dashed: 'underline decoration-dashed underline-offset-4',
            none: 'no-underline'
        },
        strikethrough: {
            true: 'line-through'
        },
        uppercase: {
            true: 'uppercase'
        },
        overflow: textOverflowVariants,
        lineClamp: lineClampVariants,
        textWrap: textWrapVariants,
        wordBreak: wordBreakVariants
    },
    defaultVariants: {}
});
const textVariantsFields = Object.keys(textVariants.variants);
const textUnderlines = Object.keys(textVariants.variants.underline);
const headingAsVariants = {
    h1: 'text-heading1',
    h2: 'text-heading2',
    h3: 'text-heading3',
    h4: 'text-heading4',
    h5: 'text-heading5',
    h6: 'text-heading6'
};
const headingAs = Object.keys(headingAsVariants);
const headingVariants = (0, external_tv_cjs_namespaceObject.tv)({
    extend: textVariants,
    variants: {
        as: headingAsVariants
    },
    defaultVariants: {
        as: 'h1',
        shade: '11'
    }
});
exports.headingAs = __webpack_exports__.headingAs;
exports.headingAsVariants = __webpack_exports__.headingAsVariants;
exports.headingVariants = __webpack_exports__.headingVariants;
exports.lineClampVariants = __webpack_exports__.lineClampVariants;
exports.lineClamps = __webpack_exports__.lineClamps;
exports.textAlignVariants = __webpack_exports__.textAlignVariants;
exports.textAligns = __webpack_exports__.textAligns;
exports.textOverflowVariants = __webpack_exports__.textOverflowVariants;
exports.textOverflows = __webpack_exports__.textOverflows;
exports.textUnderlines = __webpack_exports__.textUnderlines;
exports.textVariants = __webpack_exports__.textVariants;
exports.textVariantsFields = __webpack_exports__.textVariantsFields;
exports.textWrapVariants = __webpack_exports__.textWrapVariants;
exports.textWraps = __webpack_exports__.textWraps;
exports.wordBreakVariants = __webpack_exports__.wordBreakVariants;
exports.wordBreaks = __webpack_exports__.wordBreaks;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "headingAs",
    "headingAsVariants",
    "headingVariants",
    "lineClampVariants",
    "lineClamps",
    "textAlignVariants",
    "textAligns",
    "textOverflowVariants",
    "textOverflows",
    "textUnderlines",
    "textVariants",
    "textVariantsFields",
    "textWrapVariants",
    "textWraps",
    "wordBreakVariants",
    "wordBreaks"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
